export const PropertyCannotBeNullOrEmpty = 'PropertyCannotBeNullOrEmpty';
export const RequestFailedValidation = 'RequestFailedValidation';
export const FulfillmentPlanCannotBeModified = 'FulfillmentPlanCannotBeModified';
export const SubscriptionLimitWouldBeExceeded = 'SubscriptionLimitWouldBeExceeded';
export const ActiveSubscriptionRequired = 'ActiveSubscriptionRequired';
export const UsernameAlreadyExists = 'UsernameAlreadyExists';
export const ExceededLoginAttempts = 'ExceededLoginAttempts';
export const WorkstationLoginNotAuthorized = 'WorkstationLoginNotAuthorized';
export const EmailNotYetVerified = 'EmailNotYetVerified';
export const ProductCategoryDuplicateName = 'ProductCategoryDuplicateName';
export const ProductDuplicateSku = 'ProductDuplicateSku';
export const ThirdPartyTracking = 'ThirdPartyTracking';
export const InactiveInsuranceProvider = 'InactiveInsuranceProvider';
export const NonWalletProviderAccessFeatureRequired = 'NonWalletProviderAccessFeatureRequired';
export const ProviderNotFound = 'ProviderNotFound';
export const WalletProviderApprovalPending = 'WalletProviderApprovalPending';
export const HasExistingReturnRabbitAccount = 'HasExistingReturnRabbitAccount';
export const StoreAlreadyRegisteredEnhancedReturns = 'StoreAlreadyRegisteredEnhancedReturns';
export const DefaultAddressReturnsRabbitError = 'DefaultAddressReturnsRabbitError';
